import React from 'react'
import { lit } from 'src/utils'

export interface CardBodyProps {
    className?: string
    children: React.ReactNode
}

export function CardBody({ className, children }: CardBodyProps) {
    return <div className={lit`min-h-0 min-w-0 ${className}`}>{children}</div>
}
